import { Component, inject, input, computed } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap, of, map, combineLatest } from 'rxjs';
import { UserService, TeamService } from '../../services';
import { fullName } from '../../util';

@Component({
    selector: 'sh-referred-out',
    templateUrl: './sh-referred-out.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReferredOutComponent {
    public referredOutEmail = input<string>();
    public referredOutTeam = input<string>();
    public isInternalReferral = input<boolean>();

    private userService = inject(UserService);
    private teamService = inject(TeamService);

    private internalUser = toSignal(
        combineLatest([toObservable(this.isInternalReferral), toObservable(this.referredOutEmail)]).pipe(
            switchMap(([isInternal, email]) =>
                isInternal && email ? this.userService.getUserByEmail(email) : of(undefined)
            )
        )
    );

    protected teamName = toSignal(
        toObservable(this.referredOutTeam).pipe(
            switchMap((team) => (team ? this.teamService.getTeamById(team).pipe(map((t) => t.name)) : of(undefined)))
        )
    );

    protected internalUserName = computed(() => fullName(this.internalUser()));

    protected teamInitials = computed(() => {
        const fullTeamName = this.teamName();
        if (!fullTeamName) return '';
        return fullTeamName
            .split(' ')
            .map((word: string) => word.charAt(0))
            .join('')
            .toUpperCase();
    });
}
